import { isHttpUrl, sameSite } from "../../shared/protocol.ts";
import { parentOrigin, toParent } from "./bridge.ts";

/**
 * Links to the client's own site move the page (the chat follows, its state
 * is in sessionStorage); anything else opens a new tab. Plain <a href> would
 * navigate only this frame.
 */
export function openLink(url: string) {
  if (!isHttpUrl(url) && !/^(mailto|tel):/i.test(url)) return;
  if (parentOrigin && isHttpUrl(url) && sameSite(url, parentOrigin)) {
    toParent({ type: "navigate", url });
    return;
  }
  window.open(url, "_blank", "noopener,noreferrer");
}

/**
 * Files (a floor plan, a unit's PDF) always get a new tab: on the client's own
 * site openLink would move the page to the file and the chat would be gone.
 */
export function openFile(url: string) {
  if (isHttpUrl(url)) window.open(url, "_blank", "noopener,noreferrer");
}

/** A chat with the office on WhatsApp: wa.me takes the number as digits, country code first. */
export function whatsappUrl(number: string, text = ""): string {
  const digits = number.replace(/\D/g, "");
  return `https://wa.me/${digits}${text.trim() ? `?text=${encodeURIComponent(text.trim())}` : ""}`;
}

/** Click handler for containers with links (markdown, cards). */
export function interceptLinks(event: MouseEvent) {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const anchor = (event.target as Element | null)?.closest?.("a[href]");
  if (!(anchor instanceof HTMLAnchorElement)) return;
  event.preventDefault();
  openLink(anchor.href);
}
